import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { DictionaryCacheService } from '@/services/dictionary-cache.service';
import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

export class PropertyAttributeData {
  title: string;
  value: string;
}

@Component({
  selector: 'app-property-attribute-card',
  templateUrl: './property-attribute-card.component.html',
  styleUrls: ['./property-attribute-card.component.scss'],
  standalone: true,
  imports: [MatCardModule, RouterModule, TooltipDirective, NgIf, NgFor]
})
export class PropertyAttributeCardComponent implements OnInit {
  @Input() data: PropertyAttributeData[];
  @Input() title: string;
  @Input() tooltip: string;
  @Input() linkRouterParams: string[];
  @Input() noContent: string;
  @Input() noContent2: string;

  constructor(dictService: DictionaryCacheService) {}

  ngOnInit(): void {}
}
